import { Box, useTheme } from "@mui/material";
import { useEffect, useRef, useState } from "react";
// import { tokens } from "../../../../../theme";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { tokens } from "../../../../../../../theme";

import Text from "../../../../../../../components/theme/text/Text";

import AddIcon from '@mui/icons-material/Add';
import ButtonGroup from "../../../../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../../../../components/theme/buttons/Shbutton";

import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';

import { useTranslation } from "react-i18next";
import AllCarriersCard from "../../../../../../../components/global/cards/settings/carriers/AllCarriersCard";
import MAddCarrier from "../../../../../../../components/global/Modals/carriers/AddCarrier";
import ShDataGrid2 from "../../../../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../../../../components/theme/sidepanel2/SidepanelLoader";
import ShTextSkeleton from "../../../../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetCarriersQuery } from "../../../../../../../newapi/carrier/carrierSlice";
import { selectUserPermission } from "../../../../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../../../../../../utils/permissions';
import { useSelector } from "react-redux";
import { hexToRgb } from "../../../../../../../utils/colorConverters";

const SpCarrierDetails = SidepanelLoader(() => import("../../../../../../../components/global/Sidepanels/SpCarrierDetails/SpCarrierDetails"));

const GridActions = (props, i18n) => {
    const theme = useTheme();
    
    const {t} = useTranslation();
    return (      
        <ButtonGroup version={2}>
            {props.hasCreatePermission && (
            <Shbutton 
                onClick={() => props.handleOpen(true)}
                className={"group-btn"} 
                color={theme.palette.mode === "dark" ? "blue" : "primary"} 
                variant="contained" 
                endIcon={<AddIcon/>}>{t("new_carrier")}</Shbutton>
            )}
        </ButtonGroup>
    )
}


const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    hide:false,
};


const All = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [carrierIsExtended,setCarrierIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [addStandardOpen, setAddStandardOpen] = useState(false);
    const addStandardModal = {
        open: addStandardOpen,
        setOpen: setAddStandardOpen
    }

    const hasCreatePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.CARRIER_MANAGE])
    );

    const handleClose = () => {
        setAddStandardOpen(false);
      };

    const [carrierId, setCarrierId] = useState();
    const carrierIdRef = useRef(carrierId);
    
    const getCarrierDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.id);
        // Only update state if the productId has actually changed
        if (carrierIdRef.current !== newProductId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setCarrierId(newProductId);
            carrierIdRef.current = newProductId; // Update the ref to the new value
        }
        setCarrierIsExtended(true);
    };
    
    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions:gridOptions,
            mobileActions:<GridActions handleOpen={() => setAddStandardOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    
    const columns = [
        {field: "name", headerName: t("carrier") , flex:2, cellClassName: "carrier", renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }
            if(cellValues.row.color) {
                let rgb = [];
                let hasRgb = false;
                try{
                    if(cellValues.row.color){
                        const parsed = JSON.parse(cellValues.row.color);
                        if(parsed && parsed.hex){
                            rgb = hexToRgb(parsed.hex);
                            return (

                                <Box
                                    sx={{
                                        display:"flex",
                                        alignItems:"center",
                                        borderRadius:7,
                                        height:40,
                                        px:0.5,
                                        // background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                        // background:`rgb(${color?.[0]}, ${color?.[1]}, ${color?.[2]})`,
                                        background: `linear-gradient(rgba(${rgb?.[0] ?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1), rgba(${rgb?.[0]?? '255'}, ${rgb?.[1]?? '255'}, ${rgb?.[2]?? '255'},1)), ${theme.palette.mode === "dark" ? "black" : "white"}`, /* Solid white background */
                                        
                                        "@media screen and (max-width: 566px)" : {
                                            // px:3,
                                        }
                                    }}
                                >
                                    <Box
                                        sx={{
                                            height:32,
                                            px:1.5,
                                            // background:'orange',
                                            lineHeight:"32px",
                                            borderRadius:4,
                                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                                            boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                                            border:`1px solid ${colors.grey[100]}`,
                                        }}
                                    >
                                        <Text semibold>{cellValues.value}</Text>
                                    </Box>
                                    <Box
                                        sx={{
                                            // width:100,
                                            pr:4,
                                            height:32,
                                            borderRadius:4,
                                            "@media screen and (max-width: 566px)" : {
                                                flex:1,
                                            }
                                        }}
                                    >

                                    </Box>

                                </Box>
                            )
                        } 
                    }
                } catch(e) {
                } 
            }
            return (
                <Text semibold>{cellValues.value}</Text>
            )
        }},
        {field: "fitsPost", headerName: t("fits_dutch_post") , flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                cellValues.value === "true" || cellValues.value ?
                    <Text variant="green"><CheckOutlinedIcon fontSize="small"/></Text>:
                cellValues.value === "false" || !cellValues.value?
                    <Text variant="red"><CloseOutlinedIcon fontSize="Small" /></Text> 
                :
                    <Text variant="orange"><HorizontalRuleOutlinedIcon fontSize="Small"/></Text>
            )
        }},

        // {field: "channels", headerName: t("channels"), flex:1, renderCell : (cellValues) => {
        //     if(cellValues.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }

        //     return (
        //         <Text semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{cellValues.value}</Text>
        //     )
        // }},
        {field: "weight", headerName: `${t("weight_including_label")} (${t("gram")})`, flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{cellValues.value}</Text>
            )
        }},
        {field: "length", headerName: t("dimensions_lwh"), flex:1, renderCell : (cellValues) => {
            if(cellValues.row.skeleton) {
                return <ShTextSkeleton/>
            }

            return (
                <Text>{`${cellValues.row.length} x ${cellValues.row.width} x ${cellValues.row.height}`}</Text>
            )
        }},
        // {field: "barcodes", headerName: t("nr_of_barcodes"), flex:1, renderCell : (cellValues) => {
        //     if(cellValues.row.skeleton) {
        //         return <ShTextSkeleton/>
        //     }

        //     return (
        //         <Text>{cellValues.value}</Text>
        //     )
        // }},
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (cellValues) => {
                if(cellValues.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return (
                    <AllCarriersCard onClick={() => getCarrierDetails(cellValues)} skeleton={cellValues.row.skeleton} {...cellValues.row} />
                )
            }
        }
    ];

    return (
        <Box
            sx={{
                height:1,
                "@media screen and (max-width: 47.9375em)" : {
                    paddingTop:0,
                    paddingX:0,
                }
            }}
        >
                <ShDataGrid2 key={theme.palette.mode}
                sortModel={{field: columns[0].field,type:"ASC"}}
                    content={useGetCarriersQuery}
                    gridActions={<GridActions handleOpen={() => setAddStandardOpen(true)} hasCreatePermission={hasCreatePermission}></GridActions>} 
                    title={t("overview")}
                    gridOptions={gridOptions} 
                    onRowClick={getCarrierDetails}
                    columns={columns}>
                </ShDataGrid2>

            <MAddCarrier onOpen={() => addStandardModal.setOpen(true)} onClose={() => addStandardModal.setOpen(false)} open={addStandardModal.open} handleClose={handleClose}/>

            {spLoading && 
                <SpCarrierDetails
                    isExtended={carrierIsExtended}
                    setIsExtended={setCarrierIsExtended}
                    carrierId={carrierId}
                    // data={carrierData}   
                /> 
            }
        </Box>
    )
};

export default All;